import { connect } from 'react-redux';
import Commitment from 'routes/Commitment/components/Commitment';

const mapStateToProps = (state) => ({
  agencyId: state.auth.profile.extend.agency.id
});

export default connect(mapStateToProps)(Commitment);
